import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const View = () => {
  const [notification, setNotification] = useState({
    id: 1,
    org: "Acme Corp",
    message: "Your request for approval has been granted.",
    timestamp: "2024-05-08 14:35",
    read: 0,
  });

  const navigate = useNavigate();

  const handleDelete = () => {
    // Simulate deletion
    alert("Notification deleted!");
    navigate(-1); // Go back to previous page
  };

  return (
    <Card className="shadow-sm mt-4">
      <Card.Body>
        <h4 className="mb-3">Notification Details</h4>
        <p>
          <strong>From:</strong> {notification.org}
        </p>
        <p>
          <strong>Message:</strong> {notification.message}
        </p>
        <p>
          <strong>Date:</strong> {notification.timestamp}
        </p>

        <div className="mt-4 d-flex justify-content-end">
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default View;
